import React from 'react';
export function UserMetricMeasurement() {
  return <div data-sentry-component="UserMetricMeasurement" data-sentry-source-file="measurement.tsx">Measurement</div>;
}